export var DeliveryChannel = /*#__PURE__*/function (DeliveryChannel) {
  DeliveryChannel["WEB"] = "WEB";
  DeliveryChannel["NATIVE_IOS"] = "NATIVE_IOS";
  DeliveryChannel["NATIVE_ANDROID"] = "NATIVE_ANDROID";
  return DeliveryChannel;
}({});